import {calculateDaysDiff} from '@/lib/utils';

// Contract statuses
// 'draft' - Contract is in draft state (default) - bản nháp
// 'pending_approval' - Contract is pending approval - chờ phê duyệt
// 'approved' - Contract is approved - đã phê duyệt
// 'active' - Contract is active - đang hoạt động
// 'completed' - Contract is completed - đã hoàn thành
// 'terminated' - Contract is terminated - đã chấm dứt
// 'on_hold' - Contract is on hold - tạm dừng
// 'cancelled' - Contract is cancelled - đã hủy
// 'expired' - Contract is expired - đã hết hạn

export const ContractStatuses = [
  {id: 'draft', label: 'Bản nháp'},
  {id: 'pending_approval', label: 'Chờ phê duyệt'},
  {id: 'approved', label: 'Đã phê duyệt'},
  {id: 'active', label: 'Đang hoạt động'},
  {id: 'completed', label: 'Đã hoàn thành'},
  {id: 'terminated', label: 'Đã chấm dứt'},
  {id: 'on_hold', label: 'Tạm dừng'},
  {id: 'cancelled', label: 'Đã hủy'},
  {id: 'expired', label: 'Đã hết hạn'},
];

// Define colors based on contract status
const contractStatusColorMap = {
  draft: 'text-gray-500',
  pending_approval: 'text-blue-500',
  approved: 'text-green-500',
  active: 'text-emerald-500',
  completed: 'text-green-600',
  terminated: 'text-red-500',
  on_hold: 'text-yellow-500',
  cancelled: 'text-orange-500',
  expired: 'text-red-400',
  // others
  delayed: 'text-red-600',
  fallback: 'text-gray-500',
};

const contractStatusBgColorMap = {
  draft: 'bg-gray-100',
  pending_approval: 'bg-blue-100',
  approved: 'bg-green-100',
  active: 'bg-emerald-100',
  completed: 'bg-green-100',
  terminated: 'bg-red-100',
  on_hold: 'bg-yellow-100',
  cancelled: 'bg-orange-100',
  expired: 'bg-red-100',
  // others
  delayed: 'bg-red-100',
  fallback: 'bg-gray-100',
};

// Get status info from ContractStatuses
export const getContractStatusInfo = (statusValue, data: any = undefined) => {
  const status = ContractStatuses.find(s => s.id === statusValue) || {
    id: statusValue,
    label: statusValue,
  };

  const text = status.label;
  let color = contractStatusColorMap[status.id] || contractStatusColorMap.fallback;
  let bgcolor = contractStatusBgColorMap[status.id] || contractStatusBgColorMap.fallback;

  // Check for delayed contracts (similar to tasks)
  if (status.id === 'active') {
    const endDateVariance = calculateDaysDiff(
      data?.end_date,
      data?.actual_end_date || new Date(),
    );
    
    // If contract is past its end date but still active
    if (endDateVariance != undefined && endDateVariance > 0) {
      color = contractStatusColorMap.delayed;
      bgcolor = contractStatusBgColorMap.delayed;
    }
  }

  return {
    text,
    color,
    bgcolor,
  };
};

// Contract status color mapping for consistent UI representation
export const ContractStatusColors = {
  draft: '#6B7280', // gray
  pending_approval: '#3B82F6', // blue
  approved: '#10B981', // green
  active: '#059669', // emerald
  completed: '#10B981', // green
  terminated: '#EF4444', // red
  on_hold: '#F59E0B', // yellow
  cancelled: '#F97316', // orange
  expired: '#F43F5E', // rose
};

// Map status IDs to their positions in the color array for chart usage
export const getContractStatusColorMap = () => {
  const statusColorMap: {[key: string]: number} = {};
  const colors = Object.values(ContractStatusColors);

  ContractStatuses.forEach((status, index) => {
    statusColorMap[status.id] = index % colors.length;
  });

  return statusColorMap;
};